import { SET_STEPS, SET_STEP } from "./const";

export default {
    [SET_STEPS](state, steps) {
        state.steps = steps
    },

    [SET_STEP](state, step) {
        state.step = step
    },
}